<h4 class="upgrader-bs__title typography-title flex items-center gap-4">
  <app-game-icon game="Wheel"></app-game-icon>
  Place Your Bet
</h4>
<div class="upgrader-bs__inputs">
  <div class="upgrader-bs--bet-input">
    <app-old-slider
      [(value)]="upgraderService.betAmount"
      [min]="0"
      [step]="0.01"
      [max]="upgraderService.maxBetAmount()"
      [disabled]="upgraderService.isProcessing() || isDisabledPanel()"
      [uiSettings]="{
        thumbSize: '12px',
        trackHeight: '6px',
      }"
    ></app-old-slider>
    <app-input-options
      [disabledInput]="upgraderService.isProcessing() || isDisabledPanel()"
      [disabledOptions]="upgraderService.isProcessing() || isDisabledPanel()"
      [(value)]="upgraderService.betAmount"
      [icon]="sessionService.balanceIconSrc()"
      [options]="betInputOptions"
      [placeholder]="sessionService.balanceType() + ' value'"
      [settings]="{
      optionType: 'square',
      maskSettings: {
        mask: 'separator.2',
      },
    }"
    />
  </div>
  <div class="upgrader-bs--bet-buttons">
    @for (item of betButtons; track $index) {
    <button
      class="button button--style-primary button--style-primary-bordered padding-x-8 rounded-4 h-32"
      (click)="item.fn()"
      [disabled]="upgraderService.isProcessing() || isDisabledPanel()"
    >
      <app-balance-icon
        [balance]="sessionService.balanceType()"
        color="var(--yellow)"
      ></app-balance-icon>
      {{ item.label }}
    </button>
    }
  </div>
</div>

<div class="upgrader-bs--bottom">
  <app-fairness-button
    [href]="'/provably-fair/upgrader/'"
  ></app-fairness-button>
  <div class="upgrader-bs--seed">
    <span class="upgrader-bs--seed__title">Client Seed:</span>
    @if (typeof upgraderService.clientSeed() === 'string') {
    <span
      @fadeInAnimation
      class="upgrader-bs--seed__value"
      (click)="
        clipboardService.copy(
          upgraderService.clientSeed()!,
          'Client Seed copied!'
        )
      "
    >
      {{ upgraderService.clientSeed() }}
    </span>
    }
  </div>
</div>
